import React, {useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {userService} from "@shared/ui";

const VerifyEmail: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const userId = searchParams.has("user")? +(searchParams.get("user")!): null;
    const email = searchParams.get("email");
    const token = searchParams.get("token");

    useEffect(() => {
        console.log(userId, email, token);
        if(userId && email && token) {
            userService.verifyEmailToken(userId, email, token).then(() => {
                navigate("/profile");
            });
        }
    },[userId, email, token]);

    return null;
}

export default VerifyEmail;